import { useState } from 'react';
import InvestFormModal from './InvestFormModal';
// import AutoInvestAlertModal from './AutoInvestAlertModal';
// import InvestmentNoteDetailsModal from '../../investmentNote/views/InvestmentNoteDetailsModal';
import AvailableInvestmentNoteList from './AvailableInvestmentNoteList';
// import { useStatusModalContext } from '../../../contexts/StatusModalContext';

const NewOpportunity = (props) => {
    const { investmentNotes, isFetching, page, setPage, pageCount } = props;
    const [showInvestFormModal, setShowInvestFormModal] = useState(false);
    const [showInvestmentNoteDetailModal, setShowInvestmentNoteDetailModal] = useState(false);
    const [selectedInvestmentNote, setSelectInvestmentNote] = useState();
    // const { openStatusModal } = useStatusModalContext();
    const openStatusModal = false;

    const handleCloseInvestFormModal = () => {
        setShowInvestFormModal(false);
    };

    const handleCloseInvestmentNoteDetailModal = () => {
        setShowInvestmentNoteDetailModal(false);
    };

    const handleOpenStatusModal = () => {
        openStatusModal({
            title: 'Auto Invest',
            message: 'Opps! Something went wrong here.',
            isSuccess: false,
            refresh: false,
        });
    };

    const handleInvest = (investmentNote) => {
        setSelectInvestmentNote(investmentNote);
        setShowInvestFormModal(true);
    };

    const handleViewInvestmentNote = (investmentNote) => {
        setSelectInvestmentNote(investmentNote);
        setShowInvestmentNoteDetailModal(true);
    };

    return (
        <>
            <AvailableInvestmentNoteList
                investmentNotes={investmentNotes}
                isFetching={isFetching}
                handleViewInvestmentNote={handleViewInvestmentNote}
                handleInvest={handleInvest}
                page={page}
                setPage={setPage}
                pageCount={pageCount}
            />
            {/* <InvestFormModal
                isOpen={showInvestFormModal}
                toggle={handleCloseInvestFormModal}
                selectedInvestmentNote={selectedInvestmentNote}
            /> */}
            {/* <AutoInvestAlertModal
                isOpen={showAutoInvestAlertModal}
                toggle={handleCloseAutoInvestAlertModal}
                selectedInvestmentNote={selectedInvestmentNote}
                doInvestment={handleInvest}
            /> */}
            {/* <InvestmentNoteDetailModal
                isOpen={showInvestmentNoteDetailModal}
                toggle={handleCloseInvestmentNoteDetailModal}
                title="Review"
                selectedInvestmentNote={selectedInvestmentNote}
                setSelectInvestmentNote={setSelectInvestmentNote}
                handleOpenStatusModal={handleOpenStatusModal}
            /> */}
        </>
    );
};

export default NewOpportunity;
